import { Accordion } from "@op/sf-op";
import { cls, clx } from "@op/utils";
import { forwardRef, type HTMLAttributes } from "react";

export interface ReadingCompanionSegmentItemProps
  extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  isActive?: boolean;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  maxHeight?: number;
}

export const ReadingCompanionSegmentItem = forwardRef<
  HTMLElement,
  ReadingCompanionSegmentItemProps
>(
  (
    {
      title,
      isActive = false,
      className,
      open,
      onOpenChange,
      maxHeight,
      children,
      ...otherProps
    }: ReadingCompanionSegmentItemProps,
    ref
  ) => {
    return (
      <div
        className={cls(
          "group/2e2cb01a flex w-full cursor-pointer flex-col items-start gap-4 border-t border-solid border-neutral-border hover:bg-transparent",
          className
        )}
        ref={ref as any}
        {...otherProps}
      >
        <Accordion
          open={open}
          onOpenChange={onOpenChange}
          trigger={
            <div
              className={cls(
                "flex w-full items-center gap-2 px-4 py-3 group-hover/2e2cb01a:bg-neutral-100",
                clx({ "bg-neutral-100": isActive })
              )}
            >
              {title ? (
                <span className="grow shrink-0 basis-0 text-body-bold font-body-bold text-default-font">
                  {title}
                </span>
              ) : null}
              <Accordion.Chevron />
            </div>
          }
        >
          {children && (
            <div
              className="flex flex-col items-start gap-2 px-4 py-4 overflow-auto w-full"
              style={{ maxHeight: `calc(100dvh - ${maxHeight}px)` }}
              data-lenis-prevent=""
            >
              {children}
            </div>
          )}
        </Accordion>
      </div>
    );
  }
);
